import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { Industry, InterestedInXBT, MerchantField } from "../../types";

export const excludedCrossBorderTradeIndustries: Partial<Industry>[] = [
  "Adult",
  "Automotive",
  "Electronics",
  "Health",
  "Home & Garden (non-furniture)",
  "Jewellery",
  "Other",
  "Outdoor",
  "Services",
];

export class InterestedInXbtField extends Field<InterestedInXBT> {
  constructor(
    model: Merchant,
    opts: Partial<MerchantField<InterestedInXBT>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: "Not at this time",
      propertyName: "interestedInXBT",
      pickList: ["Yes", "Not at this time"],
      uiFieldType: "Select",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const salesChannel = this._model.storeDetails.salesChannel.value;
    const industry = this._model.storeDetails.industry.value;

    if (registeredCountry === "Canada") {
      return true;
    }

    if (!industry) {
      return false;
    }

    if (
      (registeredCountry === "Australia" ||
        registeredCountry === "New Zealand") &&
      !excludedCrossBorderTradeIndustries.includes(industry) &&
      (salesChannel === "Online and In-store" || salesChannel === "Online Only")
    ) {
      return true;
    }

    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
